import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import useSeo from "@/hooks/useSeo";

const values = [
  { icon: "ri-heart-3-line", title: "以恋爱为名", desc: "专注恋爱、后宫、暧昧、同居、校园、逆后宫题材，把每一个心动瞬间讲好。" },
  { icon: "ri-focus-3-line", title: "分类清晰", desc: "六大题材一目了然，让读者快速找到对味的作品，追更不再迷路。" },
  { icon: "ri-time-line", title: "更新及时", desc: "紧跟连载进度，热门作品每日更新，第一时间同步最新章节。" },
  { icon: "ri-community-line", title: "读者为本", desc: "倾听每一位读者的投稿与反馈，用心打磨每一期专题内容。" },
];

const testimonials = [
  { name: "恋爱番爱好者", role: "深度读者", text: "这里的恋爱后宫题材分类真的很清楚，按暧昧、校园、同居筛选一下就能找到想看的，追更体验很棒。" },
  { name: "逆后宫新人", role: "入坑读者", text: "从专题解读入坑逆后宫，编辑写得很用心，帮我理清了后宫番和逆后宫的区别，现在每周都在等更新。" },
  { name: "动漫老粉", role: "资深读者", text: "更新速度快，作品质量稳定，专题内容有深度，是我日常追更恋爱漫画的首选站点。" },
];

export default function About() {
  useSeo({
    title: "关于我们 - 羞羞动漫漫画 | 恋爱后宫题材追更平台",
    description:
      "了解羞羞动漫漫画：专注恋爱、后宫、暧昧、同居、校园、逆后宫题材漫画的内容平台，坚持分类清晰、更新及时、以读者为本的内容理念。",
    keywords: "关于羞羞动漫漫画,羞羞动漫漫画平台介绍,恋爱后宫漫画平台",
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "AboutPage",
      name: "关于羞羞动漫漫画",
      inLanguage: "zh-CN",
      description: "专注恋爱后宫题材漫画的内容平台，分类清晰，更新及时。",
    },
  });

  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 max-w-7xl mx-auto px-4 md:px-8 pb-10">
          <nav aria-label="面包屑" className="flex items-center gap-2 text-sm text-foreground-500">
            <Link to="/" className="hover:text-primary-600">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-800">关于我们</span>
          </nav>
        </section>

        <section className="relative overflow-hidden">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
              <div>
                <p className="text-sm font-medium text-primary-600 tracking-widest">ABOUT US</p>
                <h1 className="mt-3 font-heading font-black text-3xl md:text-5xl text-foreground-950 leading-tight">
                  只为热爱恋爱故事的你
                </h1>
                <p className="mt-5 text-base text-foreground-700 leading-relaxed">
                  羞羞动漫漫画是一个专注恋爱、后宫、暧昧、同居、校园、逆后宫题材的漫画内容平台。我们相信，好的恋爱故事能带给人温暖与心动，因此在海量作品中，我们只挑选那些真诚、细腻、能打动人心的作品推荐给大家。
                </p>
                <p className="mt-4 text-base text-foreground-600 leading-relaxed">
                  无论你是刚接触恋爱后宫番的新读者，还是阅番无数的老粉，这里都能让你更快找到喜欢的题材，追更不再迷路。
                </p>
                <div className="mt-6 flex flex-wrap gap-3">
                  <Link to="/category" className="whitespace-nowrap px-6 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600">
                    浏览题材分类
                  </Link>
                  <Link to="/contact" className="whitespace-nowrap px-6 py-3 rounded-full border border-background-300 text-foreground-800 text-sm font-semibold hover:border-primary-300 hover:text-primary-600">
                    联系我们
                  </Link>
                </div>
              </div>
              <div className="relative rounded-3xl overflow-hidden aspect-[4/3] bg-background-100">
                <img
                  src="https://readdy.ai/api/search-image?query=anime%20illustration%20of%20a%20group%20of%20happy%20young%20anime%20characters%20reading%20manga%20together%20in%20a%20cozy%20warm%20reading%20room%2C%20soft%20peach%20and%20cream%20background%2C%20shelves%20of%20books%2C%20warm%20glowing%20lighting%2C%20clean%20anime%20style%2C%20joyful%20and%20community%20atmosphere&width=1400&height=1050&seq=about-us-2026&orientation=landscape"
                  alt="羞羞动漫漫画平台介绍图"
                  title="羞羞动漫漫画平台介绍"
                  className="absolute inset-0 w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </section>

        <section className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-20">
          <div className="text-center mb-10">
            <p className="text-sm font-medium text-primary-600 tracking-widest">OUR VALUES</p>
            <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">我们的内容理念</h2>
            <p className="mt-3 text-sm text-foreground-600 max-w-2xl mx-auto">
              四项原则贯穿我们的内容创作与作品推荐，确保每一期内容都真诚、清晰、有用。
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
            {values.map((v) => (
              <div key={v.title} className="rounded-2xl bg-background-100 border border-background-200/70 p-6">
                <span className="w-12 h-12 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 text-xl">
                  <i className={v.icon}></i>
                </span>
                <h3 className="mt-4 font-heading font-semibold text-lg text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </section>

        <section className="bg-background-100 border-y border-background-200/70 py-14 md:py-20">
          <div className="max-w-7xl mx-auto px-4 md:px-8">
            <div className="text-center mb-10">
              <p className="text-sm font-medium text-primary-600 tracking-widest">TESTIMONIALS</p>
              <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">读者口碑</h2>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {testimonials.map((t) => (
                <div key={t.name} className="rounded-2xl bg-background-50 border border-background-200/70 p-6">
                  <div className="flex items-center gap-1 text-accent-500 text-sm">
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                    <i className="ri-star-fill"></i>
                  </div>
                  <p className="mt-4 text-sm text-foreground-700 leading-relaxed">"{t.text}"</p>
                  <div className="mt-5 flex items-center gap-3">
                    <span className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 font-semibold">
                      {t.name[0]}
                    </span>
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                      <p className="text-xs text-foreground-500">{t.role}</p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="max-w-4xl mx-auto px-4 md:px-8 py-14 md:py-20 text-center">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">加入我们一起追更</h2>
          <p className="mt-3 text-sm text-foreground-600">有任何建议或投稿想法，欢迎随时联系我们。</p>
          <Link to="/contact" className="mt-6 inline-flex items-center gap-2 whitespace-nowrap px-7 py-3 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600">
            联系我们
            <i className="ri-arrow-right-line"></i>
          </Link>
        </section>
      </main>
      <Footer />
    </div>
  );
}